import { uploadOrderProcurementFile } from '../../../HttpRequests/orders'
import { loadOrder } from '../State/order'
import handleException from '../../../Core/Helpers/handleException'
import { message } from 'antd'

export default (files) => async (dispatch, getState) => {

  const { id } = getState().screens.OrderView.order

  const formData = new FormData()
  formData.append('file', files[0])

  try {

    const response = await uploadOrderProcurementFile({ id, data: formData })

    const updatedOrder = {
      ...getState().screens.OrderView.order,
      media: response.data.media,
    }

    dispatch(loadOrder(updatedOrder))

    message.success('Procurement file uploaded')

  } catch (error) {

    handleException(error)

  }

}
